<template>
    <form-wizard
        color="#7367f0"
        :title="null"
        :subtitle="null"
        finish-button-text="Сохранить"
        next-button-text="Далее"
        back-button-text="Назад"
        class="steps-transparent"
        @on-complete="() => submitAction()"
    >
        <tab-content
                icon="feather icon-file-text"
                title="Пользователь"
                :before-change="()=> validateForm(steps['step_1'].value)"
        >
            <validation-observer
                    ref="step_1"
                    tag="form"
            >
                <b-form-group
                    label="Пользователь"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Lorem ipsum dolor sit amet, consectetur adipiscing elit"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="user"
                            rules="required"
                    >
                        <choose-user-field
                                @input="(val) => initialFormModel['user'] = val"
                                v-model="initialFormModel['user']"
                                reduceKey="id"
                        ></choose-user-field>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </validation-observer>
        </tab-content>
        <tab-content
                icon="feather icon-file-text"
                title="Разрешения"
                :before-change="()=> validateForm(steps['step_2'].value)"
        >
            <validation-observer
                    ref="step_2"
                    tag="form"
            >
                <b-form-group
                    label="Разрешения"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Lorem ipsum dolor sit amet, consectetur adipiscing elit"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="permission"
                            rules="required"
                    >
                        <choose-permission-field
                                @input="(val) => initialFormModel['permission'] = val.map( el => el['id'])"
                                v-model="initialFormModel['permission']"
                                :multiple="true"
                        ></choose-permission-field>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </validation-observer>
        </tab-content>
    </form-wizard>
</template>


<script>
    import { ref, watch } from '@vue/composition-api'

    import {BContainer, BRow, BCol, BForm, BFormGroup, BFormInput,} from 'bootstrap-vue'

    import { FormWizard, TabContent } from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'

    import { STORE_MODULE_NAME } from '@/views/apps/user_permission/model/modelStoreModule'
    import useModel from '@/views/apps/user_permission/model/useModel'

    import { validateForm } from '@core/utils/validations/utils'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import { required } from '@validations'


    import useAppElementListAddNew from "@core/components/app-elements/appElementListAddNew/useAppElementListAddNew";
    import ChooseUserField from "@/views/apps/user/components/ChooseUserField";
    import ChoosePermissionField from "@/views/apps/permission/components/ChoosePermissionField";


    export default {

        components:{
            ChoosePermissionField,
            ChooseUserField,
            BContainer, BRow, BCol,
            FormWizard, TabContent,
            BForm, BFormGroup, BFormInput,

            ValidationProvider, ValidationObserver
        },

        setup() {

            const {
                addDataUrl,
                setupData,
            } = useModel();

            const {
                formModel,
                submitAction,
            } = useAppElementListAddNew({
                storeModuleName: STORE_MODULE_NAME,
                addDataUrl: addDataUrl,
                ...setupData,
            })

            const initialFormModel = ref({
                user: "",
                permission: []
            })

            watch(initialFormModel, (val) => {
                formModel.value = val.permission.map(el => ({
                    user: val['user'],
                    permission: el
                }))

            }, { deep: true})

            const steps = {
                step_1:ref(null),
                step_2:ref(null),
            }


            return {
                submitAction,
                formModel,
                initialFormModel,

                steps, ...steps,
                validateForm,
            }
        },
    }
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
</style>
